<div class="page-content">
    <div class="content-header">
        <div class="title">
            <span class="large-screen-content">CHECK GIFT CARD BALANCE</span>
            <span class="small-screen-content">CHECK BALANCE</span>
        </div>
        <div class="actions">
            <span class="large-screen-content">
                To purchase a gift card, click
                <a
                    class="back-link"
                    color="primary"
                    (click)="goToPurchaseGiftCardPage()"
                >
                    here</a
                >.
            </span>
            <a
                class="back-link small-screen-content"
                color="primary"
                (click)="goToPurchaseGiftCardPage()"
            >
                Purchase Gift Card
            </a>
        </div>
    </div>
    <div class="content-body">
        <form [formGroup]="form">
            <mat-card>
                <mat-card-title>Please enter your gift card ID</mat-card-title>
                <div class="gift-card-input" (keyup.enter)="submitForm()">
                    <div class="form-field">
                        <mat-form-field>
                            <input
                                matInput
                                placeholder="Gift Card ID"
                                formControlName="giftCardID"
                                qa="gift-card-id-field"
                            />
                            <mat-error qa="validation-error-text"
                                >Gift Card ID is required</mat-error
                            >
                        </mat-form-field>
                    </div>
                </div>
            </mat-card>
        </form>
    </div>
    <div class="content-footer">
        <button
            mat-flat-button
            (click)="submitForm()"
            color="primary"
            qa="balance-giftcard"
            class="check-balance"
        >
            Check Balance
        </button>
    </div>
</div>
